export const tagColours = [
  '#FFBE0B',
  '#FB5607',
  '#FF006E',
  '#8338EC',
  '#3A86FF',
  '#5FF56E',
];
